import gql from 'graphql-tag';

export const GET_MAIN_APP_DATA = gql`
  query GetMainAppData {
    user {
      id
      role
      name
      email
      shouldUpdatePassword
      permissions {
        venueIds
        scopes
      }
      company {
        id
        languages
        name
        country
      }
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation RefreshToken {
    refreshToken {
      success
      error
      message
      token
    }
  }
`;
